export { StoreContext, StoreProvider } from '@roc/feature-app-core';
